module.exports = __webpack_public_path__ + "static/4-eb6661c38c79ffd8f99cb0f7d00cf918.jpg";